import React, { useState, useEffect, useRef } from 'react'
import { Spin } from 'antd'

const Loader = ({ show, tip = 'Loading...' }) => {
  const [showLoading, setShowLoading] = useState(false)
  const timer = useRef()

  useEffect(() => {
    // @ts-ignore
    timer.current = setTimeout(() => show && setShowLoading(true), 250)

    return () => {
      clearTimeout(timer.current)
      setShowLoading(false)
    }
  }, [show])

  return showLoading ? (
    <Spin data-testid="progress-loader" tip={tip} size="large" fullscreen />
  ) : null
}

export default Loader
